import { useMemo } from 'react';
import _get from 'lodash/get';
import _every from 'lodash/every';

const useBulkSelectedServiceTypeKey = deliveries =>
  useMemo(
    () => {
      if (!deliveries || deliveries.length <= 0) {
        return undefined;
      }

      const keys = deliveries.map(delivery => {
        const selectedServiceType = _get(
          delivery,
          'detail.configuration.serviceType',
        );
        const selectedSpecialServiceType = _get(
          delivery,
          'detail.configuration.specialServiceType',
        );
        return selectedServiceType && selectedSpecialServiceType
          ? `${selectedServiceType}-${selectedSpecialServiceType}`
          : undefined;
      });

      if (_every(keys, key => key === keys[0])) {
        return keys[0];
      }

      return undefined;
    },
    [deliveries],
  );

export default useBulkSelectedServiceTypeKey;
